import './email.css'

export const Email = () => {
    return (

        <div style={{ textAlign: "left", padding: "5%" }}>
            <h1>
                Invitation to African Bully Registry's Exhibition Event on April 29th</h1>

            <p>Hello <span className='yellowText'>{"<%= username %>"}</span>,</p>

            <p>We are pleased to invite you to the <span className='yellowText'>African Bully Registry's</span> upcoming event on <span className='yellowText'>Saturday, April 29th.</span> As a valued member of our dog registration community, we would be honored to have you join us for a fun-filled day of activities and networking opportunities.</p>

            <p> The event will be held at <span className='fontBold'>ABURI GARDENS</span>
       and will run from 11AM to 6PM. We have an exciting lineup of events planned for the day, including:</p>

            <ul>
                <li>Breed-specific seminars and workshops led by experts in the field</li>
                <li>Fun contests and games, such as an agility competition and best-dressed dog handler</li>
                <li>Networking opportunities with other breeders and enthusiasts in the community</li>
                <li>Exhibitions and demonstrations showcasing the best of the African Bully breed</li>
            </ul>

            <p>
                <img src='https://res.cloudinary.com/daurieb51/image/upload/v1681670675/yevmcrq4finkayz7vroe.jpg' width="100%" >
                </img>
            </p>

            <p>  Whether you're a seasoned breeder or just starting out, this event promises to be an exciting and informative day for anyone interested in the African Bully breed. There will be plenty of opportunities to learn, share, and connect with other members of our community.</p>

            <p>Registration is free for all registered users, but space is limited, so we encourage you to RSVP as soon as possible to reserve your spot.</p>


            <p>  We look forward to seeing you at the African Bully Registry's event on April 29th! If you have any questions or concerns, please don't hesitate to reach out to us at +233 20 377 5123 or +233 24 233 1674 .</p>


            <p>Below are some helpful links for more information</p>
            <p><a href="https://africanbullyregistry.com/community" className='yellowText'>AFBR Community Page</a></p>
            <p><a href="https://africanbullyregistry.com/registration" className='yellowText'>AFBR Dog Registration Page</a> </p>
            <p>   Best regards,</p>

            <p>
                Takyi Otuo

            </p>
            <p>
                African Bully Registry

            </p>        </div>
    )
}